const TUIChat = {
  '按Enter发送，Ctrl+Enter换行': 'Presione Enter para enviar, Ctrl+Enter para insertar una nueva línea',
  '表情': '[Emoticon]',
  '查看更多': 'Ver más',
  '撤回': 'Retirar',
  '撤回了一条消息': ' retiró un mensaje',
  '打开': 'Abrir',
  '单击下载': 'Haga clic para descargar',
  '下载': 'Descargar',
  '点此投诉': 'Presentar una queja',
  '点击处理': 'Haga clic para procesar',
  '对方正在输入': 'Escribiendo...',
  '发起群视频': 'Iniciar videollamada grupal',
  '发起群语音': 'Iniciar llamada de voz grupal',
  '发起通话': 'Iniciar llamada',
  '发送失败': 'Error al enviar',
  '复制': 'Copiar',
  '复制成功': 'Copiado al portapapeles',
  '该消息不存在': 'El mensaje no existe',
  '关闭阅读状态': 'Estado de lectura desactivado',
  '管理员开启全员禁言': 'El administrador habilitó Silenciar a todos',
  '欢迎使用TUICallKit': 'Bienvenido a TUICallKit',
  '回到最新位置': '',
  '回复': 'Responder',
  '回复详情': 'Respuestas',
  '集成TUICallKit': 'Integrar TUICallKit',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'Se detectó que aún no ha integrado TUI CallKit, por lo que no puede usar la función de llamadas de audio y video.',
  '结束群聊': 'Editar llamada grupal',
  '进行体验': 'para probar.',
  '经度': 'Longitud',
  '拒绝': 'Rechazar',
  '拒绝通话': 'Rechazar llamada',
  '开通腾讯实时音视频服务': 'Integración de Tencent Real-Time Communication',
  '聊天记录': '[Historial de chat]',
  '描述': 'Descripción',
  '内容包含敏感词汇': 'El contenido contiene palabras sensibles',
  '您': 'Usted',
  '您当前购买使用的套餐包暂未开通此功能': 'El paquete que adquirió no admite esta función.',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'El paquete que adquirió no admite el acuse de recibo de mensajes de grupo.',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'El paquete que adquirió no admite la lista de usuarios en línea.',
  '您已被管理员禁言': 'Ha sido silenciado por el administrador',
  '您有': 'Tiene',
  '请点击': 'Por favor haga clic',
  '请输入消息': 'Introduzca un mensaje',
  '取消': 'Cancelar',
  '取消通话': 'Cancelar llamada',
  '全部已读': 'Todos leídos',
  '确定': 'Enviar',
  '确认重发该消息？': '¿Confirmar reenviar el mensaje?',
  '人关闭阅读状态': ' cerró el estado de lectura',
  '人未读': ' sin leer',
  '人已读': ' leído',
  '删除': 'Eliminar',
  '涉及敏感内容': 'Contenido sensible',
  '申请加入': 'Solicitud para unirse',
  '视频': '[Video]',
  '视频通话': 'Videollamada',
  '条回复': 'respuestas',
  '条入群申请': 'solicitudes de ingreso al grupo',
  '条新消息': ' mensajes nuevos',
  '通话时长': 'Duración',
  '同意': 'Aceptar',
  '图片': '[Imagen]',
  '图片消息失败,无效的图片格式': 'Error al enviar la imagen, formato de imagen inválido.',
  '纬度': 'Latitud',
  '未读': 'No leído',
  '位置': '[Ubicación]',
  '文件': '[Archivo]',
  '文件不存在,请检查文件路径是否正确': 'El archivo no existe, por favor compruebe si la ruta es correcta.',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'El tamaño del archivo excede el límite; si sube un archivo, el límite máximo es de 100 MB.',
  '文件消息失败,禁止发送违规封禁的文件': 'Error en el mensaje de archivo, no está permitido enviar archivos prohibidos o vetados.',
  '我': 'Yo',
  '无法查看': 'No se puede ver',
  '无法定位到原消息': 'No se puede localizar el mensaje original',
  '无法收听': 'No se puede escuchar',
  '正在加载': 'Cargando...',
  '加载结束': 'Carga completada',
  '无应答': 'Sin respuesta',
  '系统消息': 'Mensaje del sistema',
  '消息': '[mensaje]',
  '消息或者资料中文本存在敏感内容,发送失败': 'Se encontró contenido sensible en el mensaje o en la información; envío fallido.',
  '消息详情': 'Detalle del mensaje',
  '消息长度超出限制,消息长度不要超过12K': 'La longitud del mensaje excede el límite; mantenga el mensaje por debajo de 12K.',
  '消息中图片存在敏感内容,发送失败': 'Se encontró contenido sensible en la imagen del mensaje; envío fallido.',
  '选择提醒的人': 'Seleccionar contacto',
  '已读': 'Leído',
  '已过撤回时限': 'El plazo para retirar ha pasado',
  '已接听': 'Contestada',
  '已拒绝': 'Rechazado',
  '已同意': 'Aprobado',
  '引用': 'Citar',
  '引用失败': 'Cita fallida',
  '语音': '[Voz]',
  '语音通话': 'Llamada de voz',
  '重新编辑': 'Volver a editar',
  '重新发送': 'Reenviar',
  '转发': 'Reenviar',
  '翻译': 'Traducir',
  '转文字': 'Convertir',
  '隐藏': 'Oculto',
  '转发给': 'Reenviar a',
  '自定义': '[mensaje personalizado]',
  '自定义消息': 'Mensaje personalizado',
  '腾讯云 IM': 'Tencent Cloud Chat',
  '空': 'Vacío',
  '文本包含本地审核拦截词': 'El texto contiene palabras bloqueadas por la moderación local',
  '按住说话': 'Mantener pulsado para hablar',
  '松开发送': 'Soltar para enviar',
  '松手取消': 'Soltar para cancelar',
  '录音结束提醒': 'La grabación terminará en',
  '语音播放失败': 'Error en la reproducción de voz',
  '请检查麦克风访问权限': 'Por favor, verifique los permisos de acceso al micrófono',
  '按压时间过短，请按压超过1秒': 'Presionó demasiado poco, por favor mantenga presionado más de 1 segundo',
  '正在录音': 'Grabando',
  '继续上滑可取消': 'Siga deslizando hacia arriba para cancelar',
  '松开手指 取消发送': 'Suelte el dedo para cancelar el envío',
  '此机型暂不支持复制功能': 'Este modelo no admite la función de copia',
  '请开通翻译功能': 'Por favor habilite la función de traducción',
  '请开通语音转文字功能': 'Por favor habilite la función de conversión de voz a texto',
  '翻译中': 'Traduciendo',
  '转换中': 'Convirtiendo',
  '由IM提供翻译支持': 'Soporte proporcionado por IM',
  '所有人': 'Todos',
  '已达到表情回应上限数量': 'Ha alcanzado el límite máximo de reacciones',
  '等': 'y otros',
  '人': 'usuarios',
  '返回': 'Volver',
  '关闭': 'Cerrar',
  '多选': 'Seleccionar',
  '合并转发': 'Reenvío combinado',
  '逐条转发': 'Reenviar uno por uno',
  '未选择消息': 'No se seleccionó ningún mensaje',
  '[草稿]': '[Borradores]',
  '[消息]': '[Mensaje]',
  '[文本]': '[Texto]',
  '[自定义消息]': '[Mensaje personalizado]',
  '[图片]': '[Imagen]',
  '[音频]': '[Audio]',
  '[语音]': '[Voz]',
  '[视频]': '[Video]',
  '[文件]': '[Archivo]',
  '[位置]': '[Ubicación]',
  '[地理位置]': '[Ubicación]',
  '[动画表情]': '[Sticker animado]',
  '[群提示]': '[Aviso de grupo]',
  '[群提示消息]': '[Notificación de grupo]',
  '[聊天记录]': '[Historial de chat]',
  '[机器人自定义消息]': '[Mensaje personalizado del robot]',
  '引用内容已撤回': 'El mensaje citado ha sido retirado',
  '群聊的聊天记录': 'Historial de chat del grupo',
  '和': 'y',
  '的聊天记录': 'historial de chat',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'Actualice IMSDK a la v2.10.1 o superior para ver este mensaje',
  '该群聊已被解散': 'El grupo ha sido disuelto',
  '您已被管理员移出群聊': 'Ha sido eliminado del grupo por el administrador.',
  '您已退出该群聊': 'Ha salido del grupo.',
  '您已被禁止聊天': 'Se le ha prohibido hablar',
  '账号被强制下线': 'Cuenta desconectada forzosamente',
  '登录失败': 'Error de inicio de sesión',
  '链接': '[Enlace]'
};

export default TUIChat;
